//Route Paths
const ROUTE_PATH = {
  SAMPLES: {
    LANDING: "/",
    NEW_LANDING: "/new-landing",
    ACTIONS: "/samples/actions",
  },
  GENERAL: {
    FAQ: "/faq",
    ABOUT_US: "/about-us",
    CONTACT_US: "/contact-us",
    PRICING: "/pricing",
    TNC: "/tnc",
    PRIVACY_POLICY: "/privacy-policy",
    DETAILED_FAQ: "/detailed-faq",
    SOMETHING_WENT_WRONG: "/something-went-wrong",
    HELP: "/help",
    DEMO: "/demo",
    PRODUCT_HUNT: "/producthunt",
    TANMAY: "/tanmay",
    AUTH: "/auth",
    Help1: "/help1",
    MOBILE_WEBSITE: "/mobile-website",
    HELP_NEW: "/help-new",
    NEW_DOCS: "/new-docs",
  },
  PLATFORM: {
    HOME: "/platforms/home",
    JAVASCRIPT: "/platforms/javascript",
    ANDROID: "/platforms/android",
    REACT_JS: "/platforms/reactjs",
    ANGULAR: "/platforms/angular",
  },
  PLUGINS: {
    WORDPRESS: "/plugins/wordpress",
  },
  DASHBOARD: {
    SIGNUP_LOGIN: "/dashboard/signup-login",
    HOME: "/dashboard/home",
    ACTIVITY: "/dashboard/activity",
    APPLICATION: "/dashboard/application",
    CREATE_APPLICATION: "/dashboard/create-application",
    APPLICATION_DETAILS: "/dashboard/application-details",
    PROFILE: "/dashboard/profile",
    ORGANIZATION: "/dashboard/organisation",
  },
  DOCS: {
    HOME: "/docs/home",
    API_REFERENCE: "/docs/api-reference",
    SDK: {
      HOME: "/docs/sdks",
      ANDROID: "/docs/sdks/android",
      IOS: "/docs/sdks/ios",
      JAVASCRIPT: "/docs/sdks/javascript",
      FLUTTER: "/docs/sdks/flutter",
    },
  },
  SIGNUP: "/signup",
};

export default ROUTE_PATH;
